module.exports = __webpack_public_path__ + "static/media/brushsan-5.cce0b620.png";